<template>
  <div style="display: flex;justify-content: center;align-items: center;height: calc(100vh - 84px)">
    <a-button @click="jumpRouter">跳转到园外叫料管理</a-button>
  </div>
</template>
<script>
export default {
  name: 'ExternalCallMaterial',
  methods: {
    jumpRouter() {
      const url = process.env.VUE_APP_API_LSCM_URL + '/#/purchase-execute/production-management/material-calling-management/material-calling-management-list'
      window.open(url, '_blank')
    }
  },
  created () {
    this.jumpRouter()
  }
}
</script>
